import { ActionTree } from 'vuex'
import { AppState } from '@bd/agent/types'

export const actions: ActionTree<AppState, AppState> = {
  setBottomNavigationVisibility({ commit }, visible: boolean) {
    commit('SET_BOTTOM_NAVIGATION_VISIBLE', visible, { root: true })
  },
  dialogVisibility({ commit }, payload: Partial<AppState['dialog']>) {
    commit('SET_DIALOG', payload)
  },
}
